// Common query examples for nurses and physicians
export const QUERY_EXAMPLES = {
  nurse: [
    'Show all HD patients from last week',
    'Patients with high blood pressure this month',
    'Medication errors from yesterday',
    'All appointments for today',
    'Patients admitted in the last 7 days',
  ],
  physician: [
    'My patients with diabetes',
    'My patients scheduled for today',
    'HD patients I\'m assigned to from this week',
    'My patients with abnormal vitals',
    'Appointments with my patients this month',
  ],
  doctor: [ // Alias for physician
    'My patients with diabetes',
    'My patients scheduled for today',
    'HD patients I\'m assigned to from this week',
    'My patients with abnormal vitals',
    'Appointments with my patients this month',
  ],
};

// Get placeholder text based on user role
export const getPlaceholderText = (userRole) => {
  const examples = QUERY_EXAMPLES[userRole] || QUERY_EXAMPLES.nurse;
  const randomExample = examples[Math.floor(Math.random() * examples.length)];
  return `Example: ${randomExample}`;
};

// Validate query length
export const validateQuery = (query) => {
  const minLength = 5;
  const maxLength = 500;

  if (!query || query.trim().length < minLength) {
    return { valid: false, error: `Query must be at least ${minLength} characters` };
  }

  if (query.length > maxLength) {
    return { valid: false, error: `Query must be less than ${maxLength} characters` };
  }

  return { valid: true, error: null };
};

// Format query for display
export const formatQuery = (query) => {
  return query.trim();
};
